<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'configuration_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'configuration_subtitle' | translate }}</div>
  <br />
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav class="sidenav-panel" #sidenav mode="over" position="end" [fixedInViewport]="true"
        [fixedTopGap]="isMobile() ? 120 : 64" [disableClose]="true">
        <app-configurations-modify
          [configuration]="configuration"
          [selectedAppType]="selectedAppType"
          (saved)="sidenav.close(); variableUpdated($event)"
          (cancelled)="sidenav.close(); variableCancelled($event)" 
          (loadingSpinner)="loadingSpinner($event)">
        </app-configurations-modify>
      </mat-sidenav>
    </mat-sidenav-container>

    <div fxLayout="row" fxLayoutAlign="start center">
        <mat-form-field>
            <mat-label>Select Application:</mat-label>
            <mat-select [(ngModel)]="selectedAppType" name="appType" #appType="ngModel" required (selectionChange)="onSelectionChange($event)">
              <mat-option *ngFor="let appType of appTypes" [value]="appType.value">{{ appType.viewValue }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div *ngIf="(media.isActive('lg') || media.isActive('xl') || media.isActive('md')) && selectedAppType?.length > 0" class="matTable-container">
      <mat-table matSort #table [dataSource]="dataSource"
        class="mat-elevation-z8">

        <!-- Name Column -->
        <ng-container cdkColumnDef="key">
          <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header>{{ 'configuration_key' | translate }}</mat-header-cell>
          <mat-cell fxFlex="20%" *cdkCellDef="let variable"> {{variable.key}} </mat-cell>
        </ng-container>

        <!-- Value Column -->
        <ng-container cdkColumnDef="value">
          <mat-header-cell fxFlex="70%" *cdkHeaderCellDef mat-sort-header>{{ 'configuration_value' | translate }}</mat-header-cell>
          <mat-cell fxFlex="70%" *cdkCellDef="let variable"> {{variable.value}} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="menu">
          <mat-header-cell fxFlex="10%" *cdkHeaderCellDef></mat-header-cell>
          <mat-cell fxFlex="10%" *cdkCellDef="let variable">

            <button mat-icon-button [matMenuTriggerData]="{ row: variable }" [matMenuTriggerFor]="menu" *ngIf="isAdministrator">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="updateEnvVariable(variable)" matTooltip="Update environment variable"
                matTooltipPosition="left">
                {{ 'edit' | translate }}
              </button>
            </mat-menu>

          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    
    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))" class="mobile-list">

      <mat-list-item *ngFor="let variable of dataSource.data">
        <div class="mobile-card">

          <div class="field">
            <span class="label">{{ 'configuration_key' | translate }}</span>
            <span class="value breakword">{{ variable.key }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'configuration_value' | translate }}</span>
            <span class="value breakword">{{ variable.value }}</span>
          </div>

          <div class="actions" *ngIf="isAdministrator">
            <button mat-stroked-button color="primary" (click)="updateEnvVariable(variable)">
              {{ 'edit' | translate }}
            </button>
          </div>

        </div>
      </mat-list-item>

    </mat-list>

  </con-page-layout-content>
</con-page-layout>
